import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toSlug } from "../utils/slug";
import "./ExploreMenu.css";
import { closeTopPanel, hideAcceptingForm, hidePrivateService, hideSectionBanner, hideTeamsMenu, showContentSection, showHeroBanner, toggleHeroService } from "../features/serviceSlice";

export default function ExploreMenu({ isOpen, isClosing, onClose }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showInfo } = useSelector((state) => state.service);

    const handleItemClick = (sectionTitle, itemLabel) => {
        onClose();
        dispatch(showContentSection());
        dispatch(hideAcceptingForm());
        dispatch(closeTopPanel());
        dispatch(hideSectionBanner());
        dispatch(hideTeamsMenu());
        dispatch(hidePrivateService());
        navigate(`/services/${toSlug(sectionTitle)}/${toSlug(itemLabel)}`);
    };

    const menuData = [
        {
            heading: "BLACK LABEL SERVICES",
            items: [
                { label: "COLLECTION AND DELIVERY", section: "Wardrobe Services", item: "Collection and Delivery" },
                { label: "COUTURE WET CLEANING", section: "Wardrobe Services", item: "Couture Hand Cleaning" },
                { label: "QUALITY DRY CLEANING", section: "Wardrobe Services", item: "Quality Dry Cleaning" },
                { label: "LEATHER AND SUEDE", section: "Wardrobe Services", item: "Leather and Suede" },
                { label: "LINENS AND BEDDING", section: "Estates Service", item: "Linens and Bedding" },
                { label: "WASH & FOLD", section: "Wardrobe Services", item: "Wash and Fold" },
                { label: "MOLD REMEDIATION", section: "Wardrobe Services", item: "Mold Remediation" },
                { label: "GARMENT RESTORATIONS", section: "Wardrobe Services", item: "Garment Restorations" }
            ]
        },
        {
            heading: "WARDROBE EXCLUSIVES",
            items: [
                { label: "ALTERATIONS AND TAILORING", section: "Wardrobe Services", item: "Alterations and Tailoring" },
                { label: "GARMENT RESTORATIONS", section: "Wardrobe Services", item: "Garment Restorations" }
            ]
        },
        {
            heading: "ESTATE + VESSEL EXCLUSIVES",
            items: [
                { label: "CONCIERGE RUG CARE", section: "Estates Service", item: "Concierge Rug Care" },
                { label: "ON-PREMISES LARGE RUG CARE", section: "Estates Service", item: "On-Premises Carpet Rug Care" },
                { label: "TILE + GROUT CARE", section: "Estates Service", item: "Tile and Grout care" },
                { label: "HVAC DUCT CARE", section: "Estates Service", item: "HVAC Ducts" },
                { label: "MOLD REMEDIATION", section: "Estates Service", item: "Mold + Mildew Remediation" },
                { label: "WINDOW TREATMENTS", section: "Estates Service", item: "Window Treatments" },
                { label: "OUTDOOR UPHOLSTERY", section: "Estates Service", item: "Outdoor Upholstery" },
                { label: "HUNTER DOUGLAS®", section: "Estates Service", item: "Hunter Douglas®" },
                { label: "ON-PREMISE CONSULTATION", section: "Estates Service", item: "On-Premise Consultation" }
            ]
        }
    ];

    return (
        <div className={`explore-menu-overlay ${isOpen ? "open" : ""} ${isClosing ? "closing" : ""}`}>
            <div className="closeIcon" onClick={
                () => {
                    onClose();
                    dispatch(showContentSection());
                    dispatch(hideAcceptingForm());

                    if (showInfo) {
                        dispatch(closeTopPanel())
                        dispatch(showHeroBanner())
                        dispatch(hideTeamsMenu())
                        navigate(`/services`)
                    } else {
                        dispatch(toggleHeroService())
                        dispatch(hideSectionBanner())
                        dispatch(hideTeamsMenu())
                        dispatch(hidePrivateService())
                        setTimeout(() => {
                            navigate(`/services`)
                        }, 900)

                    }
                }


            }>X CLOSE</div>
            <div onClick={(e) => e.stopPropagation()}>
                {menuData.map((section, index) => (
                    <div key={index}>
                        <p className="explore-menu-heading">
                            {section.heading}
                        </p>
                        <ul className="explore-menu-list">
                            {section.items.map((item, i) => (
                                <li
                                    key={i}
                                    onClick={() => {
                                        handleItemClick(item.section, item.item);
                                    }}
                                >
                                    {item.label}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            <ul className="menu-list info">
                <li onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                    dispatch(showContentSection());
                    dispatch(hideAcceptingForm());
                    navigate(`/philosophy`);
                }}>SERVICE PHILOSOPHY</li>
                <li onClick={(e) => {
                    e.stopPropagation();
                    onClose();
                    dispatch(showContentSection());
                    dispatch(hideAcceptingForm());
                    navigate(`/team`);
                    dispatch(hideSectionBanner());
                }}>PEOPLE</li>
            </ul>


            <div onClick={(e) => {
                e.stopPropagation();
                onClose();
                dispatch(showContentSection());
                dispatch(hideAcceptingForm());
                navigate(`/contact`);
            }} className="contact">CONTACT</div>
        </div>
    );
}
